// Runs fn once the page has finished loading (or after maxWait ms, whichever comes
// first), so the background animations don't compete with the first load.
// Right away if the page is already loaded. Returns a cancel function.
export function afterPageLoad(fn: () => void, maxWait = 2000): () => void {
  if (document.readyState === 'complete') { fn(); return () => {}; }
  let done = false;
  const run = () => {
    if (done) return;
    done = true;
    cleanup();
    fn();
  };
  const timer = window.setTimeout(run, maxWait);
  const cleanup = () => { clearTimeout(timer); window.removeEventListener('load', run); };
  window.addEventListener('load', run);
  return () => { done = true; cleanup(); };
}
